export const cnvTypeLabels = {
  0: "Deletion",
  1: "Duplication",
};

export const cnvTypeIndex = {
  deletion: 0,
  duplication: 1,
};
